<template>
    <div style="display: flex">
        <div style=" width:10%;">
            <div class="btn-item"><el-button class="echart-btn" @click="changeIndex('净报价')">净报价</el-button></div>
            <div class="btn-item"><el-button class="echart-btn" @click="changeIndex('收入')">收入</el-button></div>
            <div class="btn-item"><el-button class="echart-btn" @click="changeIndex('开票')">开票</el-button></div>
            <div class="btn-item"><el-button class="echart-btn" @click="changeIndex('回款')">回款</el-button></div>
            <!-- <div class="btn-item"><el-button class="echart-btn" @click="changeIndex('毛利润')">毛利润</el-button></div> -->
            <!-- <div class="btn-item"><el-button class="echart-btn" @click="changeIndex('在手订单')">在手订单</el-button></div> -->
        </div>
        <div style="display: flex; justify-content: center;">
            <div ref="clientPerformanceChart" style="width: 1200px; height: 300px;"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import {getClientPerformance} from '@/api/api'
export default {
    name: "StackedColumnChartNew",
    props: {
      clientName: {
        type: String,
        require: true
      },
      dateType: {
          required: true
      }
    },
    data(){
        return {
            myChart: "",
            indexName: "收入"
        }
    },

    mounted() {
        this.initCharts()
    },

    watch: {
        dateType() {
            this.changeIndex(this.indexName)
        }
    },

    methods: {

        async changeIndex(indexName) {
            this.indexName = indexName
            this.initCharts()
        },

        async initCharts() {
            const {respData} = await getClientPerformance({"client_name": this.clientName, "date_type": this.dateType})
            this.myChart = echarts.init(this.$refs.clientPerformanceChart);
            const initOption = this.handleOption(respData, this.indexName)
            this.myChart.setOption(initOption, true) 
        },

        // 处理数据
        handleOption(respData, indexName) {
            var xAxis = []
            var series = []
            var quotation = {}
            var tmp = 0

            for (var i in respData){
                xAxis.push(i)
                if(respData[i].hasOwnProperty(indexName)){
                    for (var j in respData[i][indexName]) {
                        if (quotation.hasOwnProperty(j)){
                            quotation[j].push(respData[i][indexName][j].toFixed(0))
                        }else{
                            quotation[j] = []
                            if (tmp != 0) {
                                var arr = new Array(tmp).fill(0)
                                quotation[j].push.apply(quotation[j], arr)
                            }
                            quotation[j].push(respData[i][indexName][j].toFixed(0))
                        }
                    }
                }else{

                }
                tmp = tmp+1
            }
            for (var i in quotation){
                series.push({
                    name: i,
                    type: 'bar',
                    stack: indexName,
                    barWidth: 80,
                    emphasis: {
                        focus: 'series'
                    },
                    data: quotation[i]
                })
            }
            
            return {
                title: {
                    text: indexName
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    // type: 'scroll',
                    orient: 'vertical',
                    //right: 10,
                    //top: 20,
                    //bottom: 20,
                    x: "right"
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxis
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: series
            }

        }

    }
}
</script>

<style lang="scss">
.btn-item{
    width: 100%; 
    display: flex; 
    flex-direction: column; 
    align-items: left;
    margin-top: 15px;
}
.echart-btn{
    width: 98px;
}
</style>
